module.exports = __webpack_public_path__ + "img/photo_2022-10-26_22-37-37.3ab91bdb.jpg";